import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class CveTemplateAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'nztemplate';

	getNzContent(file) {
		let request = {
			url: `${this.getAPIUrl()}/content?file=${file}`
		};

		return httpClient.getAsync(request);
	}

	submitNzContent(payload) {
		let request = {
			url: `${this.getAPIUrl()}/content`,
			data: payload
		};
		return httpClient.postAsync(request, true);
	}

	syncNz() {
		let request = {
			url: `${this.getAPIUrl()}/sync`
		};

		return httpClient.postAsync(request);
	}
}

export default new CveTemplateAPI();
